import {getField, updateField} from 'vuex-map-fields';
import Customer from '@/commonFunction/baseTableModule'

let customer = new Customer('/ws/table/customer/');

const state = {
    ...customer.state,
};
const getters = {
    ...customer.getters,
};
const actions = {
    ...customer.actions,
};
const mutations = {
    ...customer.mutations,
};

export default {
    modules: {
        Customer: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

const baseUrl = '/api/quote/'
const wsURL = '/ws/table/customer/'